import type { Theme } from "@mui/material/styles";
import type { ClassificationPropertyKey, Level } from "./schemas";

type LevelColor = { fill: string; border: string; text: string };

export const CLASSIFICATION_COLORS = ({
  palette: { purple, teal, blue },
}: Theme): Record<ClassificationPropertyKey, Record<Level, LevelColor>> => ({
  CONFIDENTIALITY: {
    0: { fill: purple["50"], border: purple["100"], text: purple["700"] },
    1: { fill: purple["100"], border: purple["200"], text: purple["700"] },
    2: { fill: purple["200"], border: purple["300"], text: purple["800"] },
    3: { fill: purple["400"], border: purple["500"], text: purple["50"] },
    4: { fill: purple["600"], border: purple["700"], text: purple["50"] },
  },
  INTEGRITY: {
    0: { fill: teal["100"], border: teal["200"], text: teal["700"] },
    1: { fill: teal["200"], border: teal["300"], text: teal["700"] },
    2: { fill: teal["300"], border: teal["400"], text: teal["800"] },
    3: { fill: teal["500"], border: teal["600"], text: teal["50"] },
    4: { fill: teal["700"], border: teal["800"], text: teal["50"] },
  },
  AVAILABILITY: {
    0: { fill: blue["50"], border: blue["100"], text: blue["700"] },
    1: { fill: blue["100"], border: blue["200"], text: blue["700"] },
    2: { fill: blue["200"], border: blue["300"], text: blue["800"] },
    3: { fill: blue["400"], border: blue["500"], text: blue["50"] },
    4: { fill: blue["600"], border: blue["700"], text: blue["50"] },
  },
});
